import { createSlice } from '@reduxjs/toolkit';
import storage from '../utils/storage';

const basePrice = 47.8;

const initialState = {
  name: '',
  email: '',
  cpf: '',
  cellphone: '',
  password: '',
  passwordConfirmation: '',

  zipcode: '',
  street: '',
  number: '',
  complement: '',
  neighborhood: '',
  stateId: '',
  state: '',
  cityId: '',
  city: '',

  creditCardNumber: '',
  creditCardHolderName: '',
  creditCardExpiry: '',
  creditCardCvc: '',
  stripeToken: '',
  mercadoPagoToken: '',

  quantity: 2,
  orderType: 2,
  ground: 'false',
  brewingMethod: '',
  brewingMethodOption: '',
  frequency: 31,
  coffees: {},

  deliveryTime: '',
  voucher: '',
  itemsToFreeShipping: '',

  coffeesPrice: 0,
  productsPrice: 0,
  shippingPrice: 0,
  discountPrice: 0,
  totalPrice: 0,

  planPage: 'plan',
  frequencyPage: 'frequency',

  products: {}
}

const cachedSubscription = storage.get('subscription') || {};

export const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState: { ...initialState, ...cachedSubscription },
  reducers: {
    updateSubscription: (state, action) => {
      let data = { ...state, ...action.payload };

      if(data.email) data.email = data.email.trim().toLowerCase();

      data.coffeesPrice = basePrice * data.quantity;

      data.productsPrice = 0;
      {Object.keys(data.products).map((id, i) => (
        data.productsPrice += data.products[id].quantity * data.products[id].price
      ))}

      data.totalPrice = data.coffeesPrice + data.productsPrice + data.shippingPrice - data.discountPrice;

      let storageData = { ...data };
      delete storageData.password;
      delete storageData.passwordConfirmation;

      storage.set('subscription', storageData);

      return data;
    },
    resetSubscription: (state, action) => {
      storage.set('subscription', initialState);
      return initialState;
    },
  },
})

export const { updateSubscription, resetSubscription } = subscriptionSlice.actions

export default subscriptionSlice.reducer
